// dot_show: false,
// number_show: false,

export const typeofbacteria_toxin = {
    core_bacteria: [
        'Akkermansia muciniphila',
        'Alistipes putredinis',
        'Bacteroidetes phylum',
        'Bacteroides fragilis',
        'Faecalibacterium prausnitzii',
        'Roseburia hominis'
    ],
    harmful_bacteria: [
        'Bacillus genus',
        'Candida albicans',
        'Clostridium difficile',
        'Escherichia coli',
        'Staphylococcus aureus'
    ],
    beneficial_bacteria: [
        'Bifidobacterium bifidum',
        'Bifidobacterium longum',
        'Lactobacillus acidophilus',
        'Lactobacillus gasseri',
        'Lactobacillus paracasei',
        'Lactobacillus rhamnosus'
    ],
}

export const scoreConfig_AllergyandEczema_toxin = [
    {
        titel: `Constipation`,
        match_key: 'Constipation',
        Xdotpos: 177,
        Ydotpos: 568,
        Xnumberpos: 580,
        Ynumberpos: 541,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 23,
        dot_show: false,
        number_show: false,        
        value_use: [
            // 'Faecalibacterium prausnitzii',
            'Staphylococcus aureus',
            // 'Bifidobacterium lactis',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            // 'Lactobacillus plantarum',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Diarrhea`,
        match_key: 'Diarrhea',
        Xdotpos: 177,
        Ydotpos: 674,
        Xnumberpos: 580,
        Ynumberpos: 647,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 23,
        dot_show: false,
        number_show: false,         
        value_use: [
            // 'Faecalibacterium prausnitzii',
            // 'Roseburia hominis',
            // 'Bacillus',
            'Candida albicans',
            'Clostridium difficile',
            'Escherichia coli',
            'Staphylococcus aureus',
            // 'Lactobacillus reuteri',
            'Lactobacillus rhamnosus',
            // 'Streptococcus thermophilus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Immune disorder`,
        match_key: 'Immune disorder',
        Xdotpos: 177,
        Ydotpos: 777,
        Xnumberpos: 580,
        Ynumberpos: 750,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 23,
        dot_show: false,
        number_show: false,           
        value_use: [
            // 'Alistipes putredinis',
            // 'Roseburia hominis',
            // 'Bifidobacterium breve',
            'Bifidobacterium longum',
            // 'Lactobacillus helveticus',
            'Lactobacillus paracasei',
            // 'Streptococcus thermophilus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    }
]
